// need to do this to make jquery plugins work: https://laracasts.com/discuss/channels/vite/using-jquery-libraries-w-vite
import $ from 'jquery';

// eslint-disable-next-line no-multi-assign
window.$ = window.jQuery = $;
